export const DESSERTS: string[] = [
  "riskrem",
  "sjokoladepudding",
  "karamellpudding",
  "frukt",
  "julekaker",
];
